import React from 'react'
import { CircularProgress } from '@mui/material';
import useVisitorPageHooks from './visitorPage-hook';
import styles from './visitorPage.module.scss';
import MrByte from './UITemplates/MrByte/Screen/byte';

export enum VisitorPageContents {
  MENU = "menu",
  PROFILE = "profile",
  MY_ORDERS = "my_orders"
};


const VisitorPage: React.FC = () => {
  const { isSuccess, tab, businessData, dineInLocation, dineInLocationFromUrl } = useVisitorPageHooks();

  return (
    <div className={styles.page}>
      {isSuccess && businessData
        ?
        <MrByte
          data={businessData!}
          type={tab}
          dineInLocation={dineInLocation}
          dineInLocationFromUrl={dineInLocationFromUrl}
        />
        :
        <CircularProgress sx={{ color: '#b00020' }} size='25px' />
      }
    </div>
  )
}

export default VisitorPage